var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.multiTabEvent,"color":"secondary","timeout":-1,"top":"","center":""}},[_vm._v("Changes have been detected. Please refresh to stay up to date."),_c('v-btn',{staticClass:"ml-2 refresh-btn",attrs:{"text":""},on:{"click":_vm.refresh}},[_vm._v("refresh")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }